import { StatusFinishedEnum } from '@helpers/enums';
import { ISetting } from '../admin/iSetting';
import { IHomeFilters } from '../generals/iHomeFilters';
import { IMyNegotiationsTypesFilters } from '../generals/iMyNegotiationsTypesFilters';
import { IPortfolioFilters } from '../generals/iPortfolioFilter';
import { IProgressFilters } from '../generals/iProgressFilter';
import { IReportFilters } from '../generals/iReportFilters';
import { IMonitorsFilters } from '@models/generals/iMonitorsFiltersClass';

export interface ISettings {
  locale: string;
  valuesSystem: ISetting[];
  reportFiltersStorage: IReportFilters;
  portfolioFiltersStorage: IPortfolioFilters;
  monitorsFiltersStorage: IMonitorsFilters;
  homeFiltersStorage: IHomeFilters;

  myNegotiationsTypesFiltersStorage: IMyNegotiationsTypesFilters;
  progressFiltersStorage: IProgressFilters;
  filterStatusFinishedEnum?: StatusFinishedEnum[];
}

class SettingsClass implements ISettings {
  locale: string;
  valuesSystem: ISetting[] = [];
  reportFiltersStorage: IReportFilters;
  portfolioFiltersStorage: IPortfolioFilters;
  monitorsFiltersStorage: IMonitorsFilters;
  homeFiltersStorage: IHomeFilters;
  myNegotiationsTypesFiltersStorage: IMyNegotiationsTypesFilters;
  progressFiltersStorage: IProgressFilters;
  filterStatusFinishedEnum?: StatusFinishedEnum[] = [];

  constructor(
    locale: string,
    valuesSystem: ISetting[],
    reportFiltersStorage: IReportFilters,
    portfolioFiltersStorage: IPortfolioFilters,
    monitorsFiltersStorage: IMonitorsFilters,
    homeFiltersStorage: IHomeFilters,
    myNegotiationsTypesFiltersStorage: IMyNegotiationsTypesFilters,
    progressFiltersStorage: IProgressFilters,
    filterStatusFinishedEnum?: StatusFinishedEnum[],
  ) {
    this.locale = locale;
    this.valuesSystem = valuesSystem;
    this.reportFiltersStorage = reportFiltersStorage;
    this.portfolioFiltersStorage = portfolioFiltersStorage;
    this.homeFiltersStorage = homeFiltersStorage;
    this.myNegotiationsTypesFiltersStorage = myNegotiationsTypesFiltersStorage;
    this.progressFiltersStorage = progressFiltersStorage;
    this.filterStatusFinishedEnum = filterStatusFinishedEnum;
    this.monitorsFiltersStorage = monitorsFiltersStorage;
  }
}

export default SettingsClass;
